/**
 * @Description 列表
 */

import { FC, ReactNode } from 'react';
import V2Table from '@/common/components/Data/V2Table';
import { ButtonProps } from 'antd';
import styles from '../index.module.less';
import { beautifyThePrice, isNotEmptyAny } from '@lhb/func';
// import { isNotEmptyAny } from '@lhb/func';
interface TableProps {
  onRefresh?: (value: any) => void
  selectedRowKeys?: any[];
  tableData?: any[];
  setSelectedRowKeys?: (value: any) => void;
  onAction?: (key: string, recoder: any) => void;
  message?: ReactNode;
  onSortOrderChange?: (value: any) => void;
  refreshCurrent?: boolean; // 当前页刷新
  rowSelection?: any;
  onFetch?: () => void;
  filters?: any;
  rowSelectionOperate?: Array<{
    text: string,
    onClick: any,
    icon?: any,
    btnConfig?: ButtonProps
  }>;
  /**
   * @description 从1页重新加载
   */
  reload?: () => void;
  /**
   * @description 从当前页重新加载
   */
   currentReload?: () => void;

  //  modColumn?: any;

   [key: string]:any;
}

const TableList: FC<TableProps> = ({
  onFetch,
  filters,
  refreshCurrent,
  isCommunity,
  isALQCommunity = false,
  // modColumn,
  ...props
}) => {
  const renderNoWrapTitle = (title: string) => <span className={styles.nowrapHeader}>{title}</span>;

  const columns:any = isCommunity ? [
    {
      key: 'name',
      title: `小区名称`,
      dragChecked: true,
      importWidth: true,
      width: 150,
    },
    {
      key: 'houseHolds',
      title: `户数`,
      dragChecked: true,
      width: 'auto',
    },
    {
      key: 'areaProportion',
      title: renderNoWrapTitle('面积占比'),
      dragChecked: true,
      width: 110,
      render: value => (isNotEmptyAny(value) ? `${beautifyThePrice(value, ',', 0,)}%` : '-'),
    },
    {
      key: 'weightedHomeNumber',
      title: renderNoWrapTitle('加权户数(户)'),
      dragChecked: true,
      width: 130,
      render: value => (isNotEmptyAny(value) ? `${beautifyThePrice(value, ',', 0,)}` : '-'),
    },
    {
      key: 'liveNum',
      title: renderNoWrapTitle('居住人口'),
      dragChecked: true,
      width: 110,
    },
    {
      key: 'housePrice',
      title: `参考房价`,
      dragChecked: true,
      importWidth: true,
      width: 130,
    },
    {
      key: 'buildTime',
      title: renderNoWrapTitle('建筑年份(年)'),
      dragChecked: true,
      importWidth: true,
      width: 130,
      render: value => (isNotEmptyAny(value) ? `${value}` : '-'),
    },
    {
      key: 'address',
      title: `地址`,
      dragChecked: true,
      importWidth: true,
      minWidth: 220,
      width: 220,
    },
  ] : [
    {
      key: 'name',
      title: '名称',
      dragChecked: true,
      importWidth: true,
      width: 223,
    },
    {
      key: 'address',
      title: '地址',
      dragChecked: true,
      importWidth: true,
      width: 223,
    },
    // https://zentao.lanhanba.com/bug-view-34875.html
    // {
    //   key: 'distance',
    //   title: `距离`,
    //   dragChecked: true,
    //   width: 72,
    //   forceTooltipRender(_: any) {
    //     return isNotEmptyAny(_) ? (_ + 'm') : '-';
    //   },
    //   render(_: any) {
    //     return isNotEmptyAny(_) ? (_ + 'm') : '-';
    //   }
    // },
  ];

  // 仅奥乐齐详情使用新列；分享态及其他周边配套沿用原列配置。
  const displayColumns = isCommunity && isALQCommunity ? [
    {
      key: 'communityNo',
      title: renderNoWrapTitle('编号'),
      dragChecked: true,
      width: 90,
      render: value => (isNotEmptyAny(value) ? String(value) : '-'),
    },
    {
      key: 'name',
      title: `小区名称`,
      dragChecked: true,
      importWidth: true,
      width: 150,
    },
    {
      key: 'areaProportion',
      title: renderNoWrapTitle('面积占比'),
      dragChecked: true,
      width: 110,
      render: value => (isNotEmptyAny(value) ? `${beautifyThePrice(value, ',', 0,)}%` : '-'),
    },
    {
      key: 'weightedHomeNumber',
      title: renderNoWrapTitle('加权户数(户)'),
      dragChecked: true,
      width: 130,
      render: value => (isNotEmptyAny(value) ? `${beautifyThePrice(value, ',', 0,)}` : '-'),
    },
    {
      key: 'housePrice',
      title: `参考房价`,
      dragChecked: true,
      importWidth: true,
      width: 120,
    },
    {
      key: 'buildTime',
      title: renderNoWrapTitle('建筑年份(年)'),
      dragChecked: true,
      importWidth: true,
      width: 130,
      render: value => (isNotEmptyAny(value) ? `${value}` : '-'),
    },
    {
      key: 'communityTypeList',
      title: renderNoWrapTitle('小区类型'),
      dragChecked: true,
      importWidth: true,
      width: 180,
      // 正式接口提供多个类型名称，全部展示。
      render: value => (Array.isArray(value) && value.length ? value.join('、') : '-'),
    },
    {
      key: 'liveNum',
      title: renderNoWrapTitle('居住人口'),
      dragChecked: true,
      width: 110,
    },
    {
      key: 'abnormal',
      title: renderNoWrapTitle('异常小区'),
      dragChecked: true,
      width: 110,
      // 缺失与 false 区分，不能把缺失标识当作正常小区。
      render: value => (value === true ? '是' : value === false ? '否' : '-'),
    },
  ] : columns;

  return (
    <>
      <V2Table
        key={isCommunity ? (isALQCommunity ? 'alq-community' : 'community') : 'business'}
        pageSize={10}
        paginationConfig={{
          simple: true,
          ...(isCommunity && isALQCommunity ? { showTotal: undefined } : {}),
        }}
        className={styles['table-list']}
        rowKey={isCommunity && isALQCommunity ? 'communityRowKey' : 'name'}
        filters={filters}
        scroll={{ x: 'max-content' }}
        defaultColumns={displayColumns}
        onFetch={onFetch}
        refreshCurrent={refreshCurrent}
        voluntarilyEmpty
        hideColumnPlaceholder
        {...props}
      />
    </>
  );
};

export default TableList;
